// src/features/medicalSercices/page/planGroupForm.tsx

import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import DynamicForm, { type DynamicFormSchema } from '@/common/components/DynamicForm/DynamicForm';
import { useTranslation } from 'react-i18next';

export default function PlanGroupForm() {
    const { t } = useTranslation();
    const planGroupFormSchema: DynamicFormSchema = {
        layout: 'vertical', // Overall form layout
        // submitButtonText: 'Save User', // Custom text for the submit button
        showResetButton: true, // Show a reset button

        // Define form sections for better organization and complex layouts
        sections: [
            {
                key: 'planGroup-details', // Unique key for the section
                title: 'Plan Group Form', // Title displayed if type is 'card'
                type: 'card', // This section will be rendered inside an Ant Design Card
                layout: { type: 'grid', gutter: 24 }, // Fields within this section use a 2-column grid with 24px gutter
                fields: [

                    {
                        name: 'name',
                        label: 'Name',
                        type: 'input',
                        required: true,
                        requiredMessage: t('Please enter a name.'), // Custom required message
                        autocomplete: 'false',
                        pattern: 'AlphaNumericWithSpaceHyphenApostropheAmpersandCommaDotSlashBrackets',
                        validation: [
                            { min: 3, message: t('Name must be at least 3 characters long.') },
                            { max: 50, message: t('Name cannot be more than 50 characters long.') },
                        ],
                        colSpan: 24, // Takes 12 out of 24 grid units (half width)
                    },
                    {
                        name: 'description',
                        label: 'Description',
                        type: 'input',
                        required: true,
                        requiredMessage: t('Please enter a service plan group description.'), // Custom required message
                        autocomplete: 'false',
                        validation: [
                            { max: 350, message: t('Description cannot be more than 350 characters long.') },
                        ],
                        colSpan: 24, // Takes 12 out of 24 grid units (half width)
                    },
                    {
                        name: 'isActive',
                        label: 'Status',
                        type: 'switch',
                        colSpan: 12, // Full width
                        defaultValue: true, 
                    },
                ],
            },

        ],
    };

    return (
        <DynamicForm
            schema={planGroupFormSchema}
            submitApiUrl={API_ENDPOINTS.INSURANCEPLAN.SAVE_PLANGROUP}
            getByIdApiUrl={API_ENDPOINTS.INSURANCEPLAN.GET_PLANGROUP_BY_ID}
            updateApiUrl={API_ENDPOINTS.INSURANCEPLAN.UPDATE_PLANGROUP}
            refreshTableDataKey={QUERY_KEYS.INSURANCEPLAN.PLANGROUPS}
            refreshSecondKey={["dropdownData","plangroup"]}
        />
    );
}
